import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { useSignOut } from '~/features/auth/queries/useAuth'
import { removeAuthInfo } from '~/features/auth/utils/auth'
import MyInfo from '~/features/mypage/MyInfo'
import PurchasedInfo from '~/features/mypage/PurchasedInfo'
import { useMyInfo } from '~/features/mypage/queries/useMyInfo'
import TicketInfo from '~/features/mypage/TicketInfo'
import defaultProfileImage from '~/shared/assets/images/default-profile.png'
import Button from '~/shared/components/buttons/Button'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import Tabs from '~/shared/components/tab/Tabs'
import useViewport from '~/shared/hooks/useViewport'
import { mypageTabState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function MyPage() {
  const navigate = useNavigate()
  const viewport = useViewport()
  const { enqueueSnackbar } = useSnackbar()
  const [mypageTabIndex, setMypageTabIndex] = useRecoilState(mypageTabState)

  const { isLoading, data } = useMyInfo()

  const { userInfo } = data! || {}

  const { mutate: signOutMutate } = useSignOut()

  const refreshToken = localStorage.getItem('starlike-refresh-token')

  const signOut = () => {
    removeAuthInfo()
    signOutMutate(
      {
        refreshToken: refreshToken as string,
      },
      {
        onSuccess: (res) => {
          if (!res.errorCode) {
            enqueueSnackbar('로그아웃 되었습니다.', { variant: 'success' })
            navigate('/')
          }
        },
      },
    )
  }

  return (
    <Wrapper>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <UserInfo>
            <div>
              <img
                className="profile-image"
                src={defaultProfileImage}
                alt="profile"
              />
              <span className="email">{userInfo.email}</span>
            </div>
            {viewport < theme.deviceSizes.medium ? null : (
              <Button
                onClick={signOut}
                $width={141}
                $height={58}
                $fontSize={24}
                $variant="primary"
              >
                로그아웃
              </Button>
            )}
          </UserInfo>
          <Tabs
            tabContents={['내 정보', '구매 입장권', '내 결제 정보']}
            selectedTab={mypageTabIndex}
            $size="md"
            setSelectTab={setMypageTabIndex}
          />

          {mypageTabIndex === 0 ? (
            <MyInfo myInfo={userInfo} />
          ) : mypageTabIndex === 1 ? (
            <TicketInfo />
          ) : mypageTabIndex === 2 ? (
            <PurchasedInfo />
          ) : (
            <></>
          )}
        </>
      )}
    </Wrapper>
  )
}

export default MyPage

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;

  box-sizing: border-box;
  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  padding-top: ${theme.size.headerHeight}px;

  @media ${theme.device.large} {
    gap: 24px;

    width: 100%;
    height: auto;
    margin-top: ${theme.size.mobileHeaderHeight + 26}px;
    padding: 20px;

    /* padding-top: 0; */
  }
`

const UserInfo = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;

  width: 100%;

  div {
    display: flex;
    gap: 36px;
    align-items: center;

    @media ${theme.device.medium} {
      gap: 20px;
    }
  }

  .profile-image {
    width: 120px;
    height: 120px;
    background-color: aliceblue;
    border-radius: 50%;

    @media ${theme.device.medium} {
      width: 80px;
      height: 80px;
    }
  }
`
